export default {"src":"/_next/static/media/walking-bridge-sm.colour.be94443e.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};